export var PaymentMethodTypes;
(function (PaymentMethodTypes) {
    PaymentMethodTypes["Card"] = "card";
    PaymentMethodTypes["Bacs"] = "bacs_debit";
    PaymentMethodTypes["Paypal"] = "paypal";
})(PaymentMethodTypes || (PaymentMethodTypes = {}));
